/** Reserves footer layout space before the lazy Footer chunk loads (prevents CLS on mobile). */
export default function FooterRouteFallback() {
  return <div className="daiv-footer-page-anchor daiv-footer-page-anchor--reserved" aria-hidden="true" />;
}
